export default function () {
    const menuToggle = document.querySelectorAll('.js-menu-toggle, .js-close-menu');
    const mobileMenu = document.querySelector('#mobile-menu');
    const closeMenu = document.querySelectorAll('.js-close-menu, .js-off-canvas-overlay');

    function toggleNav() {
        mobileMenu.classList.toggle('show');
    }

    function hideNav() {
        mobileMenu.classList.remove('show');
    }

    if (menuToggle.length > 0) {
        menuToggle.forEach(function(element) {
            element.addEventListener('click', toggleNav);
        });
    }

    if (closeMenu.length > 0) {
        closeMenu.forEach(function(element) {
            element.addEventListener('click', hideNav);
        });
    }
}
// Toggle Menu
// $('.js-menu-toggle, .js-close-menu').click(function toggleNav() {

//     $('#mobile-menu').toggleClass('show');

// });

// $('.js-close-menu, .js-off-canvas-overlay').click(function hideNav() {

//     $('#mobile-menu').removeClass('show');

// });
